<h1 mat-dialog-title>
    {{assignmentConfig.title | translate}}
</h1>
<div mat-dialog-content class="assignment-grid-dialog">
    <ng-content></ng-content>
</div>
<div mat-dialog-actions>
    <span *ngIf="this.gridService && this.gridService.collection.selectionLength > 0"
          class="assigned-items-count">
        {{gridService.collection.selectionLength}}
        {{(this.gridService.collection.selectionLength > 1 ? 'items selected' : 'item selected') | translate}}
    </span>
    <mx-button [buttonModel]="closeButton"></mx-button>
    <mx-button [buttonModel]="okButton"></mx-button>
</div>
<mx-preloader [preloaderName]="preloaderName"></mx-preloader>
